import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { RestInputContext } from 'components/RestInput/RestInputContext';
import { centresOfMeBasicSelectors } from 'redux/centresOfMeBasic/selectors';
import { useSelector } from 'react-redux';
import ListCheckboxSelect from './ListCheckboxSelect';

const CentreListMultiSelect = ({ retrieveList }) => {
  const { record } = useContext(RestInputContext);
  const data = useSelector(centresOfMeBasicSelectors.getDataArr);
  const paging = useSelector(centresOfMeBasicSelectors.getResourceData);
  const loading = useSelector(centresOfMeBasicSelectors.getLoading);

  const defaultValue = useMemo(
    () => record.centres?.map((item) => item?.id),
    [record.centres],
  );

  return (
    <ListCheckboxSelect
      retrieveList={retrieveList}
      name="centreIds"
      defaultValue={defaultValue}
      data={data}
      paging={paging}
      loading={loading}
      selectedResourceTitles="users.selectedCentresTotal"
      selectedResourceTitle="users.selectedCentreTotal"
    />
  );
};

CentreListMultiSelect.propTypes = {
  retrieveList: PropTypes.func,
};

export default CentreListMultiSelect;
